import { render, staticRenderFns } from "./AddUnitsDialog.vue?vue&type=template&id=863f0454&scoped=true&"
import script from "./AddUnitsDialog.vue?vue&type=script&lang=js&"
export * from "./AddUnitsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863f0454",
  null
  
)

export default component.exports